import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-visor-video',
  templateUrl: './visor-video.component.html',
  styleUrls: ['./visor-video.component.scss']
})
export class VisorVideoComponent implements OnInit {
  @Input() videoSource = '';
  @Output() estadoVideo = new EventEmitter<string>();
  // @Output() outputRecurrence = new EventEmitter<any>();
  @ViewChild('videoPlayer') videoplayer: ElementRef;



  video = document.getElementById("video");
  timeStarted = -1;
  timePlayed = 0;
  duration = 0;
  constructor() { }




  
  ngOnInit(): void {

    console.log('video', this.video, this.videoplayer);
    // this.videoSource = 'http://www.w3schools.com/html/mov_bbb.mp4';
    // if (this.videoplayer.nativeElement.readyState > 0)
    //   this.getDuration.call(this.videoplayer.nativeElement);
    // //If metadata not loaded, use event to get it
    // else {
    //   this.videoplayer.addEventListener('loadedmetadata', this.getDuration);
    // }




  }

  videoPlay() {
    console.log('im Play!', this.videoplayer.nativeElement.currentTime, this.videoplayer.nativeElement.duration);
    this.videoplayer.nativeElement.play();
    // this.videoplayer.nativeElement.currentTime;

  }
  videoPause() {
    console.log('im pause!', this.videoplayer.nativeElement.currentTime, this.videoplayer.nativeElement.duration);

    if (this.videoplayer.nativeElement.currentTime > this.videoplayer.nativeElement.duration * 0.8) {
      // console.log('video complete');
      this.estadoVideo.emit('completo');

    }else {
      this.estadoVideo.emit('incompleto');

    }
    // this.videoplayer.nativeElement.currentTime;

  }

  skip(value) {
    // let video: any = document.getElementById("my_video_1");
    this.videoplayer.nativeElement.currentTime += value;
  }


  toggleVideo(event: any) {
    console.log('togle', event)
    this.videoplayer.nativeElement.play();




    // this.videoplayer.nativeElement.addEventListener("play", this.videoStartedPlaying);
    // this.videoplayer.nativeElement.addEventListener("playing", this.videoStartedPlaying);
    // this.videoplayer.nativeElement.addEventListener("ended", this.videoStoppedPlaying);
    // this.videoplayer.nativeElement.addEventListener("pause", this.videoStoppedPlaying);


  }


  // // remember time user started the video
  // videoStartedPlaying() {
  //   this.timeStarted = new Date().getTime() / 1000;
  // }
  // videoStoppedPlaying(event) {
  //   // Start time less then zero means stop event was fired vidout start event
  //   if (this.timeStarted > 0) {
  //     const playedFor = new Date().getTime() / 1000 - this.timeStarted;
  //     this.timeStarted = -1;
  //     // add the new ammount of seconds played
  //     this.timePlayed += playedFor;
  //   }
  //   document.getElementById("played").innerHTML = Math.round(this.timePlayed) + "";
  //   // Count as complete only if end of video was reached
  //   if (this.timePlayed >= this.duration && event.type == "ended") {
  //     document.getElementById("status").className = "complete";
  //   }
  // }

  // getDuration() {
  //   this.duration = this.videoplayer.nativeElement.duration;
  //   document.getElementById("duration").appendChild(new Text(Math.round(this.duration) + ""));
  //   console.log("Duration: ", this.duration);
  // }




















}



// var video = document.getElementById("video");

// var timeStarted = -1;
// var timePlayed = 0;
// var duration = 0;


// // If video metadata is laoded get duration
// if (video.readyState > 0)
//   getDuration.call(video);
// //If metadata not loaded, use event to get it
// else {
//   video.addEventListener('loadedmetadata', getDuration);
// }
// // remember time user started the video
// function videoStartedPlaying() {
//   timeStarted = new Date().getTime() / 1000;
// }
// function videoStoppedPlaying(event) {
//   // Start time less then zero means stop event was fired vidout start event
//   if (timeStarted > 0) {
//     var playedFor = new Date().getTime() / 1000 - timeStarted;
//     timeStarted = -1;
//     // add the new ammount of seconds played
//     timePlayed += playedFor;
//   }
//   document.getElementById("played").innerHTML = Math.round(timePlayed) + "";
//   // Count as complete only if end of video was reached
//   if (timePlayed >= duration && event.type == "ended") {
//     document.getElementById("status").className = "complete";
//   }
// }

// function getDuration() {
//   duration = video.duration;
//   document.getElementById("duration").appendChild(new Text(Math.round(duration) + ""));
//   console.log("Duration: ", duration);
// }

// video.addEventListener("play", videoStartedPlaying);
// video.addEventListener("playing", videoStartedPlaying);

// video.addEventListener("ended", videoStoppedPlaying);
// video.addEventListener("pause", videoStoppedPlaying);
